<template>
  <div>
    <!-- <div
      class="container"
      style="background-color: white; padding: 10px;"
      v-click-outside="onClickOutside"
    > -->
    <div v-click-outside="onClickOutside">
      <div class="row">
        <div class="col-12">
          <b-input-group class="mb-3 cursor-pointer">
            <a
              v-if="isDisabled === false"
              @click="reloadCategories"
              class="btn reset-select"
            >
              <i class="bx bx-reset" /> Reset
            </a>
            <template #append>
              <b-input-group-text @click="onSwitchToggleCategories">
                <i class="mdi mdi-menu-down" style="line-height: 1;"></i>
              </b-input-group-text>
            </template>
            <b-form-input
              :readonly="isDisabled"
              v-model="filter"
              placeholder="เลือกหมวดหมู่"
              :class="isSubmit ? 'select-success' : ''"
              :state="state"
              @click="onSwitchToggleCategories"
            ></b-form-input>
            <div class="validate-invalid">
              <span>{{ invalidFeedback }}</span>
            </div>
          </b-input-group>
        </div>
      </div>

      <template v-if="toggleCategories">
        <div class="container testimonial-group mb-5">
          <div
            class="testimonial-group-row text-center"
            v-if="objs && objs.length"
          >
            <div
              class="testimonial-group-row-col-xs-4 auto-scroll border-vertical col custom-scroll-bar  mb-3"
              v-for="index in level"
              :key="index"
              :Style="
                `height: ${height}px; width: 280px;padding: 0; ${styleClass}`
              "
            >
              <b-table
                hover
                responsive
                :fields="['displayName']"
                :items="objs.filter(q => q.level === index - 1)"
                thead-class="hidden_header"
                :tbody-tr-class="rowClass"
                class="table table-borderless table-nowrap"
                @row-clicked="handlerActive"
              >
                <template v-slot:cell(displayName)="data">
                  <div class="row cursor-pointer">
                    <div class="col-6 text-left">{{ data.value }}</div>
                    <div class="col-6 text-right">
                      <i
                        v-if="
                          data.item[childrenItemsKey] &&
                            data.item[childrenItemsKey].length
                        "
                        class="bx bx-chevron-right"
                      >
                      </i>
                    </div>
                  </div>
                </template>
              </b-table>
            </div>
          </div>
          <div class="row" v-if="onShowBtnSubmit">
            <div class="col-md-12 mt-4" style="margin-bottom: 20px">
              <button
                type="button"
                class="btn btn-success"
                style="padding: 5px;"
                @click="result"
              >
                <i class="bx bx-check" />Submit
              </button>
            </div>
          </div>
        </div>
        <!-- <div class="mapping-lists">
          <div class="row mapping-lists-item" v-if="objs && objs.length">
            <div
              v-for="index in level"
              :key="index"
              class="auto-scroll border-vertical col custom-scroll-bar"
              :Style="`height: ${height}px; padding: 0; ${styleClass}`"
            >
              <b-table
                hover
                responsive
                :fields="['displayName']"
                :items="objs.filter(q => q.level === index - 1)"
                thead-class="hidden_header"
                :tbody-tr-class="rowClass"
                class="table table-borderless table-nowrap"
                @row-clicked="handlerActive"
              >
                <template v-slot:cell(displayName)="data">
                  <div class="row cursor-pointer">
                    <div class="col-6">{{ data.value }}</div>
                    <div class="col-6 text-right">
                      <i
                        v-if="
                          data.item[childrenItemsKey] &&
                            data.item[childrenItemsKey].length
                        "
                        class="bx bx-chevron-right"
                      >
                      </i>
                    </div>
                  </div>
                </template>
              </b-table>
            </div>
          </div>
          
          <div class="row">
            <div
              v-if="onShowBtnSubmit"
              class="col-md-12 mt-4"
              style="margin-bottom: 20px"
            >
              <button
                type="button"
                class="btn btn-success"
                style="padding: 5px;"
                @click="result"
              >
                Submit
              </button>
            </div>
          </div>
        </div> -->
      </template>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import vClickOutside from 'v-click-outside'

Vue.use(vClickOutside)
export default {
  props: {
    level: Number,
    displayKey: String,
    idKey: String,
    childrenItemsKey: String,
    defaultValue: String,
    items: {
      type: Array,
      default: null,
    },
    height: {
      type: Number,
      default: 300,
    },
    // backgroundColor: {
    //     type: String,
    //     default: '#eee'
    // },
    styleClass: {
      type: String,
      default: '',
    },
    isShowTextSelector: {
      type: Boolean,
      default: true,
    },
    reload: {
      type: Boolean,
      default: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isValidate: {
      type: Boolean,
      default: false,
    },
    isSelectLastChild: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      blockNumber: [12, 6, 4, 3, 3, 2],
      objs: [],
      objDefaults: [],
      values: [],
      filter: '',
      filterList: [],
      toggleCategories: false,
      isSubmit: false,
      isLastChild: false,
    }
  },
  mounted() {
    this.init()
  },
  computed: {
    state() {
      return this.isValidate ? this.isSubmit : null
    },
    invalidFeedback() {
      return this.isValidate && !this.isSubmit ? 'กรุณากรอกข้อมูล' : ''
    },
    onShowBtnSubmit() {
      return (
        this.values !== null &&
        this.values.length > 0 &&
        (!this.isSelectLastChild || this.isLastChild)
      )
    },
  },
  watch: {
    filter() {
      if (this.filter === '') {
        this.reloadCategories()
        return
      }
      if (
        this.isSubmit &&
        this.filter !== this.values.map(val => val.displayName).join(' > ')
      ) {
        this.values = []
        this.isSubmit = false
        this.$emit('result', { isSuccess: false, value: [], id: '' })
      }
      if (this.filter && this.values.length === 0) this.toggleCategories = true

      let _search = []
      if (this.filter) {
        _search = this.filterList.filter(q =>
          q.displayName.toLowerCase().includes(this.filter.toLowerCase())
        )
        // console.log('_search', _search)
        if (_search.length) this.search(_search)
        else this.resetActive()
      } else this.resetActive()
    },
    defaultValue() {
      if (this.defaultValue !== undefined && this.defaultValue !== '')
        this.generateDefaultValue()
    },
    reload(value) {
      this.reloadCategories()
    },
    items: {
      handler() {
        this.init()
      },
      deep: true,
    },
  },
  methods: {
    reloadCategories() {
      this.filter = ''
      this.isSubmit = false
      this.values = []
      this.resetActive()
      this.$emit('result', { isSuccess: this.isSubmit, value: [], id: '' })
      this.$emit('resetitems', true)
    },
    onClickOutside() {
      // console.log('onClickOutside', this.isSubmit)
      this.toggleCategories = false
    },
    onSwitchToggleCategories() {
      if (!this.isDisabled) {
        this.toggleCategories = !this.toggleCategories
      }
    },
    init() {
      this.objs = this.items.map(val => {
        return {
          id: val[this.idKey],
          displayName: val[this.displayKey],
          level: 0,
          items: val[this.childrenItemsKey],
          isActive: false,
        }
      })

      this.filterList = this.items.map(val => {
        return {
          id: val[this.idKey],
          parents: [],
          displayName: val[this.displayKey],
          level: 0,
        }
      })

      for (var i = 0; i < this.objs.length; i++) {
        this.getChildren(this.objs[i])
      }
      this.objDefaults = this.objs
      /* set default value */
      this.generateDefaultValue()
    },
    generateDefaultValue() {
      if (
        this.defaultValue !== undefined &&
        this.defaultValue !== '' &&
        this.filterList.length > 0
      ) {
        var objDefault = this.filterList.filter(q => q.id === this.defaultValue)
        if (objDefault !== undefined && objDefault.length > 0) {
          this.search(objDefault)
          this.filter = this.values.map(val => val.displayName).join(' > ')
          this.toggleCategories = false
          this.isSubmit = true
          // this.result()
        }
      }
    },
    getChildren(obj) {
      if (obj && obj.items && obj.items.length) {
        // for value
        let _items = obj.items.map(val => {
          return {
            id: val[this.idKey],
            displayName: val[this.displayKey],
            level: val.level,
            items: val[this.childrenItemsKey],
            isActive: false,
          }
        })
        this.$delete(obj, 'items')
        this.$set(obj, 'items', _items)

        // for search
        let _objParent = this.filterList.filter(q => q.id === obj.id)[0]
        let _parents = [{ level: obj.level, id: obj.id }]
        if (_objParent !== undefined) _parents.push(..._objParent.parents)

        let _itemsSearch = _items.map(val => {
          return {
            id: val.id,
            parents: _parents,
            displayName: val.displayName,
            level: val.level,
          }
        })
        this.filterList.push(..._itemsSearch)

        for (var i = 0; i < obj.items.length; i++) {
          this.getChildren(obj.items[i])
        }
      }
    },
    rowClass(item, type) {
      if (item && type === 'row') return item.isActive ? 'active' : ''
      else return null
    },
    handlerActive(item) {
      // console.log('active', item.items)
      if (this.isSelectLastChild) this.isLastChild = item.items.length === 0

      let removeActiveItems = this.objs.filter(q => q.level === item.level)
      for (let i = 0; i < removeActiveItems.length; i++) {
        removeActiveItems[i].isActive = false
      }
      item.isActive = true
      this.generateData(item.level)
      this.values = this.objs
        .filter(q => q.isActive)
        .map(val => {
          return {
            id: val.id,
            displayName: val.displayName,
            level: val.level,
            isActive: val.isActive,
          }
        })
    },
    generateData(level) {
      let _obj = this.objs.filter(q => q.level <= level)
      let _filterData = _obj.filter(q => q.level === level && q.isActive)[0]
      if (_filterData) {
        let childrenItems = _filterData.items
        for (let i = 0; i < childrenItems.length; i++) {
          _obj.push({
            id: childrenItems[i].id,
            displayName: childrenItems[i].displayName,
            level: level + 1,
            items: childrenItems[i].items,
            isActive: false,
          })
        }
      }

      this.objs = _obj
    },
    search(items) {
      if (items && items.length) {
        this.objs = this.objDefaults
        let filterObjIds = items.map(val => val.id)
        let maxLevel = Math.max.apply(
          Math,
          items.map(val => val.level)
        )
        let _lastLevelSortItems = this.levelSorted(items, true)
        let defaultItemsids = []
        defaultItemsids.push(
          ..._lastLevelSortItems[0].parents.map(val => val.id)
        )
        filterObjIds.push(...defaultItemsids)
        defaultItemsids.push(_lastLevelSortItems[0].id)
        this.objs = this.objs.filter(q => filterObjIds.includes(q.id))
        for (let i = 0; i <= maxLevel; i++) {
          let item = this.objs.filter(
            q => defaultItemsids.includes(q.id) && q.level === i
          )[0]
          if (item) this.handlerActive(item)
        }
      }
    },
    resetActive() {
      this.objs = this.objDefaults
      this.objs = this.objs.filter(q => q.level === 0)
      let removeActiveItems = this.objs
      for (let i = 0; i < removeActiveItems.length; i++) {
        removeActiveItems[i].isActive = false
      }
      this.values = []
    },
    levelSorted: function(items, isSortAsc) {
      function compare(a, b) {
        if (a.level < b.level) return isSortAsc ? -1 : 1
        if (a.level > b.level) return isSortAsc ? 1 : -1
        return 0
      }

      return items.sort(compare)
    },
    result() {
      this.filter = this.values.map(val => val.displayName).join(' > ')
      this.toggleCategories = false
      this.isSubmit = true
      this.$emit('result', {
        isSuccess: this.isSubmit,
        value: this.values,
        id:
          this.values && this.values.length > 0
            ? this.values[this.values.length - 1].id
            : '',
      })
      // this.resetActive()
    },
  },
}
</script>
<style>
.mapping-lists {
  top: 40px;
  position: absolute;
  background-color: #fff;
  width: calc(100% + 300px);
  /* width: 400px; */
  z-index: 9;
  font-size: 10px;
  padding: 12px 12px 0 12px;
  box-shadow: 0 0.5rem 1.25rem rgba(18, 38, 63, 0.1);
  overflow-x: auto;
  white-space: nowrap;
}
.custom-scroll-bar::-webkit-scrollbar {
  width: 10px;
  padding-bottom: 20px;
  padding-top: 18px;
}
.custom-scroll-bar::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.custom-scroll-bar::-webkit-scrollbar-thumb {
  background: #9a9a9a;
}
.custom-scroll-bar::-webkit-scrollbar-thumb:hover {
  background: #888;
}

.testimonial-group {
  border: #888;
  border-width: initial;
  border-style: dotted;
}

.testimonial-group-row {
  overflow-x: auto;
  white-space: nowrap;
}
.testimonial-group-row-col-xs-4 {
  display: inline-block;
  float: none;
}

.select-success {
  color: green;
  background-color: azure;
}
.cursor-pointer {
  cursor: pointer;
}
.input-group-icon {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0.47rem 0.75rem;
  margin-bottom: 0;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #eff2f7;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
.hidden_header {
  display: none;
}
.cursor-pointer {
  cursor: pointer;
}
.auto-scroll {
  overflow-y: auto;
}
.border-vertical {
  border-right: 1px solid #eee;
}
.border-vertical:last-child {
  border-right: 0px;
}
.mt-1 {
  margin-top: 1rem;
}
.mt-2 {
  margin-top: 2rem;
}
.mt-3 {
  margin-top: 3rem;
}
.mt-4 {
  margin-top: 4rem;
}
.mt-5 {
  margin-top: 5rem;
}
.mt-6 {
  margin-top: 6rem;
}
.mt-10 {
  margin-top: 10rem;
}
.mb-1 {
  margin-bottom: 1rem;
}
.font-14 {
  font-size: 14px;
}
.font-16 {
  font-size: 16px;
}
.font-18 {
  font-size: 18px;
}
.font-20 {
  font-size: 20px;
}
.text-red {
  color: #f10;
}
.text-green {
  color: green;
}
.width-300 {
  width: 300px;
}
</style>
